@if (ehrGenerateError()) {
  <nz-alert [nzMessage]="ehrErrorTmpl" />

  <ng-template #ehrErrorTmpl>
    <div class="flex flex-col gap-4">
      <div [innerText]="ehrGenerateError()"></div>
      <div>
        @if (needToAddClinic()){
          <button nz-button (click)="activateEhr()">
            ელექრონული ანკეტის სისტემის აქტივაცია
          </button>
        } @else {
          <button nz-button (click)="addOrEdit()">
            ინფორმაციის დამატება
          </button>
        }
      </div>
    </div>

  </ng-template>
}

<div class="mb-4 border-b-2 border-gray-200 pb-2">
  ანკეტის ნომერი: <span class="font-bold ">{{ ehrNo() }}</span>
</div>
<form [formGroup]="form" nz-form nzLayout="horizontal">
  <nz-form-item>
    <nz-form-label nzSpan="24" [nzRequired]="true" nzFor="employeeId">
      თანამშრომელი
    </nz-form-label>
    <nz-form-control [nzErrorTip]="'აუცილებელია'">
      <nz-select formControlName="employeeId" nzSize="large" [nzAllowClear]="true" [nzShowSearch]="true">
        @for (employee of visitAddFacade.uniqueEmployees(); track employee.id) {
          <nz-option [nzLabel]="employee.name" [nzValue]="employee.id" />
        }
      </nz-select>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item>
    <nz-form-label nzSpan="24" [nzRequired]="true" nzFor="procedures">
      პროცედურები
    </nz-form-label>
    <nz-form-control>
      <nz-select nzMode="multiple" formControlName="procedures" nzSize="large">
        @for (procedure of procedures(); track procedure.value) {
          <nz-option [nzLabel]="procedure.label" [nzValue]="procedure.value"></nz-option>
        }
      </nz-select>
    </nz-form-control>
  </nz-form-item>

  <div class="my-4">
    <ul nz-list nzBordered nzSize="large">
      <nz-list-header>
        <div class="flex justify-between items-center">
          <div>NCSP კოდები</div>
          <div>
            <button nz-button nzType="primary" (click)="addNCSP()">
              <i nz-icon nzType="plus" nzTheme="outline"></i>
              დამატება
            </button>
          </div>
        </div>
      </nz-list-header>
      @for (ncspCode of ncspCodes(); track ncspCode) {
        <li nz-list-item nzNoFlex>
          <ul nz-list-item-actions>
            <nz-list-item-action>
              <button nz-button nzType="primary" nzSize="small"
                      nz-popconfirm
                      nzPopconfirmTitle="ნამდვილად გსურთ ამ NCSP კოდის წაშლა?"
                      (nzOnConfirm)="deleteNCSP(ncspCode)">
                <i nz-icon nzType="delete" nzTheme="outline"></i>
              </button>
            </nz-list-item-action>
          </ul>
          {{ ncspCode.code }} - {{ ncspCode.nameGeo }}
        </li>
      }
    </ul>
  </div>
  <div nz-row [nzGutter]='24'>
    <!--    <div nz-col nzSpan="24">-->
    <!--      <nz-form-item>-->
    <!--        <nz-form-label nzSpan="24" [nzRequired]="true" nzFor="icdCode">ძირითადი დიაგნოზი(ICD)</nz-form-label>-->
    <!--        <nz-form-control [nzErrorTip]="'აუცილებელია'">-->
    <!--          <nz-tree-select-->
    <!--            formControlName="icd10Id"-->
    <!--            [nzNodes]="classificationCodeService.classificationICDCodes()"-->
    <!--            nzShowSearch-->
    <!--            nzPlaceHolder="Please select"-->
    <!--            nzVirtualHeight="300px"-->
    <!--            nzHideUnMatched="true"-->
    <!--            nzCheckStrictly="true"-->
    <!--            nzShowLine="true"-->
    <!--            nzSize="large"-->
    <!--          ></nz-tree-select>-->
    <!--          &lt;!&ndash;          <nz-select formControlName="icd10" nzSize="large" [nzAllowClear]="true" [nzShowSearch]="true"&ndash;&gt;-->
    <!--          &lt;!&ndash;                     (nzOnSearch)="onICDSearch($event)">&ndash;&gt;-->
    <!--          &lt;!&ndash;            @for (icd of classificationICDCodes(); track icd.id) {&ndash;&gt;-->
    <!--          &lt;!&ndash;              <nz-option [nzLabel]="icd.code" [nzValue]="icd.id" [nzCustomContent]="true">&ndash;&gt;-->
    <!--          &lt;!&ndash;                <span>{{ icd.code }} - {{ icd.name }}</span>&ndash;&gt;-->
    <!--          &lt;!&ndash;              </nz-option>&ndash;&gt;-->
    <!--          &lt;!&ndash;            }&ndash;&gt;-->
    <!--          &lt;!&ndash;          </nz-select>&ndash;&gt;-->
    <!--        </nz-form-control>-->
    <!--      </nz-form-item>-->
    <!--    </div>-->
    <div nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="templateId">შაბლონი</nz-form-label>
        <nz-form-control>
          <div nz-row [nzGutter]="8">
            <div nz-col [nzSpan]="23">
              <nz-select
                nzSize="large"
                formControlName="templateId"
                nzPlaceHolder="აირჩიეთ შაბლონი"
                nzAllowClear>
                @for (template of templates(); track template.id) {
                  <nz-option [nzLabel]="template.name" [nzValue]="template.id"/>
                }
              </nz-select>
            </div>
            <div nz-col [nzSpan]="1">
              <button
                nz-button
                nzType="text"
                nzSize="large"
                [disabled]="!form.get('templateId')?.value"
                (click)="viewTemplateContent()"
                style="padding: 4px 8px;">
                <span nz-icon nzType="eye" nzTheme="outline"></span>
              </button>
            </div>
          </div>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <nz-collapse [nzBordered]="false" [style]="{
      'border': 'none',
      'background': 'transparent',
      'margin-top': '20px'
    }">
    <nz-collapse-panel [style]="customStyle" nzHeader="პაციენტის ანამნეზი">
      @if (userId) {
        <beautyapp-patient-anamnesis [parentForm]="form" [userId]="userId" />
      }
    </nz-collapse-panel>
  </nz-collapse>

  <nz-divider />


</form>

<div class="text-right mt-4 flex gap-4 justify-between">
  <button nz-button nzType="default" nzSize="large" type="button" (click)="modalRef.close()">
    <i nz-icon nzType="close" nzTheme="outline"></i>
    დახურვა
  </button>

  <nz-space>
    <button
      *nzSpaceItem
      (click)="onSubmit()"
      [nzLoading]="submitLoading()"
      [disabled]="form.invalid"
      nz-button nzType="primary" nzSize="large">
      <i nz-icon nzType="save" nzTheme="outline"></i>
      შენახვა
    </button>
  </nz-space>
</div>
